// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BaseGallery-wrapper-3bqdvQkeSX","item":"BaseGallery-item-QTbxm3rMET","large":"BaseGallery-large-3RoFOaU29N"};